module.exports = __webpack_public_path__ + "static/media/drop_mass_outline.0fd786d0.svg";